import * as Yup from 'yup';

const schema = Yup.object().shape({
  type: Yup.string().required('Este campo é obrigatório.'),
  indicator: Yup.string().required('Este campo é obrigatório.'),
});

export default schema;
